export const WORKSHOPS = [
    {
        id: 1,
        price: 5,
        enTitle: "Pearl & Jewelry Making",
        viTitle: "Mở trai lấy ngọc & làm trang sức",
        enDescription: "Open an oyster yourself and discover your own pearl. This workshop offers an authentic experience as the pearl is revealed and crafted into a personalized piece of jewelry.",
        viDescription: "Tự tay mở trai, khám phá viên ngọc của riêng bạn. Workshop với trải nghiệm chân thực khi viên ngọc dần lộ ra và được hoàn thiện thành món trang sức mang dấu ấn cá nhân.",
        thumbnail: "/ngoctrai.jpg"
    },
    {
        id: 2,
        price: 5,
        enTitle: "Conical Hat Painting",
        viTitle: "Vẽ nón",
        enDescription: "Paint your own conical hat and create your own design. This workshop is a space to experiment with colors and drawings, where each stroke is gradually completed on a unique hat.",
        viDescription: "Tự tay vẽ nón, tạo nên thiết kế của riêng mình. Workshop là không gian để thử nghiệm màu sắc và hình vẽ, nơi từng nét vẽ được hoàn thiện dần trên một chiếc nón không trùng lặp.",
        thumbnail: "/non.jpg"
    },
    {
        id: 3,
        price: 5,
        enTitle: "Lacquer Blind Box",
        viTitle: "Túi mù sơn mài",
        enDescription: "Grind it yourself and discover the colors hidden inside. This workshop offers a slow-paced experience where each layer of lacquer is gradually revealed, creating a surprise.",
        viDescription: "Tự tay mài, khám phá màu sắc ẩn bên trong. Workshop mang đến trải nghiệm chậm rãi, nơi từng lớp sơn dần được hé lộ và tạo nên một kết quả không thể đoán trước.",
        thumbnail: "/sonmai.jpg"
    },
    {
        id: 4,
        price: 5,
        enTitle: "Mug Stone Studding",
        viTitle: "Đính đá lên cốc",
        enDescription: "Attach stones yourself to create a highlight for your mug. The workshop allows you to choose and arrange details, so each finished mug has a unique touch.",
        viDescription: " Tự tay đính đá, tạo điểm nhấn cho chiếc cốc của bạn. Workshop cho phép lựa chọn và sắp xếp chi tiết theo ý thích, để mỗi chiếc cốc hoàn thiện đều mang một dấu ấn khác nhau.",
        thumbnail: "/coc.jpg"
    },
    {
        id: 5,
        price: 5,
        enTitle: "Canvas Bag Painting",
        viTitle: "Vẽ túi vải",
        enDescription: "Color and complete a bag yourself based on an available pattern. This workshop is designed to be easy and beginner-friendly, where you just choose colors and follow instructions.",
        viDescription: "Tự tay tô màu, hoàn thiện chiếc túi theo hình có sẵn. Workshop được thiết kế dễ làm, dễ bắt đầu, nơi chỉ cần chọn màu và làm theo hướng dẫn để tạo nên chiếc túi mang nét riêng.",
        thumbnail: "/tuivai.jpg"
    },
    {
        id: 6,
        price: 5,
        enTitle: "Leather Bag Stone Studding",
        viTitle: "Đính đá túi da",
        enDescription: "Attach stones yourself to turn the bag into your own version. The workshop focuses on small details, where accents are intentionally added to create a standout bag.",
        viDescription: "Tự tay đính đá, biến chiếc túi thành phiên bản của riêng bạn. Workshop tập trung vào từng chi tiết nhỏ, nơi các điểm nhấn được thêm vào một cách có chủ ý để tạo nên chiếc túi nổi bật.",
        thumbnail: "/tuida.jpg"
    }
]